export function openExternal(url: string): void {
  try {
    const cap = (window as { Capacitor?: { isNativePlatform?: () => boolean; Plugins?: { Browser?: { open: (opts: { url: string }) => void } } } }).Capacitor;
    if (cap?.isNativePlatform?.()) {
      const browser = cap.Plugins?.Browser;
      if (browser?.open) {
        browser.open({ url });
        return;
      }
    }
  } catch {
    // fall through to window.open
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
